import { createContext } from 'react';

interface ITravelAppContext {
  cookie: string;
  growthbookError?: boolean;
}

export const TravelAppContext = createContext<ITravelAppContext>({
  cookie: '',
  growthbookError: false,
});

export const TravelPassContext = createContext({ data: {} });

export const RootContext = createContext<any>({});
